module.exports = __webpack_public_path__ + "static/media/05_465.62b7b549.jpg";